module.exports = __webpack_public_path__ + "img/l.c035c05.png";